import { config } from 'app/config';
import { Version } from './footer.styled';

export const Footer = () => {
  return <Version>{config.version}</Version>;
};
